import { JsonProperty } from "../requests/jsonparser";
import { BaseModel } from "./base";

export class ProfanityWord extends BaseModel {

    @JsonProperty({ type: 'string' })
    word: string;
}
